import { connect } from 'react-redux'

import MailPinkSlip from './MailPinkSlip'

import { getFromSettings } from 'src/utils/helpers'
import { setPinkSlipAddress, getPinkSlipAddresses, sendPinkSlipAddress } from './actions'

const mapDispatchToProps = {
  getPinkSlipAddresses,
  setPinkSlipAddress,
  getFromSettings,
  sendPinkSlipAddress,
}

const mapStateToProps = state => {
  return {
    addresses: state.mailPinkSlipReducer.pinkSlipAdresses,
    document: state.documents.document,
    loading: state.mailPinkSlipReducer.loading,
    loaded: state.mailPinkSlipReducer.loaded,
    labels: getFromSettings(state, 'labels', {}),
    address: state.mailPinkSlipReducer.pinkSlipAdress,
    submitting: state.mailPinkSlipReducer.submitting,
    features: state.appReducer.features,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MailPinkSlip)
